import { config } from 'config';
import httpClient from '@/resources/http-client.js';
import { flyweight } from 'commons/util/interfaces';
import { REST } from 'commons/rest/rest.js';
import { getCookie } from '@/store/modules/sites/actions.js';
import { refreshUserToken } from '@/resources/auth.js';
import { authorizationRequestInterceptor, createRefreshRetryHandler } from '@/resources/auth-token.js';

/**
 * auth.{env} endpoint
 *
 */
function IAmAPI() {
    REST.call(this, httpClient, config.iam_url);

    this.api.interceptors.request.use(authorizationRequestInterceptor);
    this.api.interceptors.response.use((response) => response.data.result || response.data,
        createRefreshRetryHandler(this.api, refreshUserToken));
}

IAmAPI.prototype = Object.create(REST.prototype);

const iamAPI = flyweight(IAmAPI);

export const getIamAPI = () => iamAPI.register();

const routes = {
    current_user: () => '/v3/sections/',
    user_by_uuid_and_section: (uuid, sectionUuid) => `/v3/sections/${sectionUuid}/users/${uuid}`,
};

/* Fetches the current user information from the new IAM endpoint.
 * Is used to retrieve user-accessible sections and roles.
 * Note: The existing call to currentUser will not be replaced yet, as a refactor of the console is required.
 * In the future, after the refactor, this endpoint will fully replace the old currentUser information.
*/
export const fetchCurrentUserSections = () => {
    const scope = getCookie('loginSessionUuid');
    return getIamAPI().get(`${routes.current_user()}${scope}/users/me`);
};

export const fetchUserByUuidAndSection = (uuid, sectionUuid) =>
    getIamAPI().get(routes.user_by_uuid_and_section(uuid, sectionUuid));
